import { useLanguage } from "@/hooks/useLanguage";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

const BlogHero = () => {
  const { t, language, localizePath } = useLanguage();

  return (
    <section className="bg-secondary/30 pt-40 pb-16">
      <div className="container mx-auto px-4 md:px-6">
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={localizePath("/")} className="text-muted-foreground hover:text-accent">
                  Home
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-accent font-medium">Blog</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6">
            {t("blogPage.heroTitle")}
          </h1>
          <p className="text-lg text-muted-foreground">
            {t("blogPage.heroDescription")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
